// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Define colors for pending and success statuses *
/* Conditional styling for order status */
.order-table tbody tr.success:hover {
  background-color: #aaffaa; /* Green hover effect for success status */
}

.order-table tbody tr.pending:hover {
  background-color: #ffcccc; /* Red hover effect for pending status */
}

.order-heading,
.order-filter-container {
  margin-left: 186px; /* Space for admin navbar */
  color: #333;
  font-family: 'Roboto', sans-serif; /* Set font family */
}

.order-filter-container {
  margin-bottom: 20px;
}

.order-search-bar,
.order-date-input {
  font-size: 16px;
  padding: 8px;
  margin-right: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.order-search-bar:focus,
.order-date-input:focus {
  outline: none;
  border-color: #007bff;
}

.order-reset-button {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.order-table-container {
  overflow-x: auto;
  margin-left: 90px; /* Space for admin navbar */
  width: calc(100% - 90px); /* Adjust the width based on the page width */
}

.order-table {
  border-collapse: collapse;
  width: 100%; /* Set table width to 100% */
  font-family: 'Roboto', sans-serif; /* Set font family */
  
}

.order-table th,
.order-table td {
  
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  max-width: 200px; /* Limit maximum width of table cells */
  white-space: nowrap; /* Prevent wrapping of text */
  overflow: hidden; /* Hide overflow text */
  text-overflow: ellipsis; /* Show ellipsis for overflow text */
  font-size: 14px; /* Reduce font size */
}

.order-table th {
  background-color: #f2f2f2;
}

/* Hover effect for table rows */
.order-table tbody tr:hover {
  background-color: #f8aaaa; /* Change background color on hover */
}

.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  animation: slide-in 0.5s ease;
  position: relative; /* Add this line */
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}


@keyframes slide-in {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}


@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Media query for screens up to 768px */
@media screen and (max-width: 768px) {
  .order-heading,
  .order-filter-container {
    margin-left: 0;
    padding: 10px;
  }

  .order-search-bar,
  .order-date-input {
    width: calc(50% - 10px);
    margin-right: 5px;
  }

  .order-reset-button {
    width: calc(50% - 10px);
    margin-right: 0;
  }

  .order-table-container {
    width: 100%; /* Reset width for mobile */
    margin-left: 0; /* Reset left margin for mobile */
  }
}

`, "",{"version":3,"sources":["webpack://./src/Admin/OrderManagement/OrderManagement.css"],"names":[],"mappings":"AAAA;yCACyC;AACzC;EACE,yBAAyB,EAAE,0CAA0C;AACvE;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;;EAEE,kBAAkB,EAAE,2BAA2B;EAC/C,WAAW;EACX,iCAAiC,EAAE,oBAAoB;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB,EAAE,2BAA2B;EAC9C,wBAAwB,EAAE,6CAA6C;AACzE;;AAEA;EACE,yBAAyB;EACzB,WAAW,EAAE,4BAA4B;EACzC,iCAAiC,EAAE,oBAAoB;;AAEzD;;AAEA;;;EAGE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB,EAAE,uCAAuC;EACzD,mBAAmB,EAAE,6BAA6B;EAClD,gBAAgB,EAAE,uBAAuB;EACzC,uBAAuB,EAAE,oCAAoC;EAC7D,eAAe,EAAE,qBAAqB;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,yBAAyB,EAAE,qCAAqC;AAClE;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB,EAAE,kBAAkB;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;;AAGA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wCAAwC;AACxC;EACE;;IAEE,cAAc;IACd,aAAa;EACf;;EAEA;;IAEE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW,EAAE,2BAA2B;IACxC,cAAc,EAAE,iCAAiC;EACnD;AACF","sourcesContent":["/* Define colors for pending and success statuses *\n/* Conditional styling for order status */\n.order-table tbody tr.success:hover {\n  background-color: #aaffaa; /* Green hover effect for success status */\n}\n\n.order-table tbody tr.pending:hover {\n  background-color: #ffcccc; /* Red hover effect for pending status */\n}\n\n.order-heading,\n.order-filter-container {\n  margin-left: 186px; /* Space for admin navbar */\n  color: #333;\n  font-family: 'Roboto', sans-serif; /* Set font family */\n}\n\n.order-filter-container {\n  margin-bottom: 20px;\n}\n\n.order-search-bar,\n.order-date-input {\n  font-size: 16px;\n  padding: 8px;\n  margin-right: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.order-search-bar:focus,\n.order-date-input:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.order-reset-button {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.order-table-container {\n  overflow-x: auto;\n  margin-left: 90px; /* Space for admin navbar */\n  width: calc(100% - 90px); /* Adjust the width based on the page width */\n}\n\n.order-table {\n  border-collapse: collapse;\n  width: 100%; /* Set table width to 100% */\n  font-family: 'Roboto', sans-serif; /* Set font family */\n  \n}\n\n.order-table th,\n.order-table td {\n  \n  border: 1px solid #dddddd;\n  text-align: left;\n  padding: 8px;\n  max-width: 200px; /* Limit maximum width of table cells */\n  white-space: nowrap; /* Prevent wrapping of text */\n  overflow: hidden; /* Hide overflow text */\n  text-overflow: ellipsis; /* Show ellipsis for overflow text */\n  font-size: 14px; /* Reduce font size */\n}\n\n.order-table th {\n  background-color: #f2f2f2;\n}\n\n/* Hover effect for table rows */\n.order-table tbody tr:hover {\n  background-color: #f8aaaa; /* Change background color on hover */\n}\n\n.fade-in {\n  animation: fadeIn 0.5s ease-in-out;\n}\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.overlay-content {\n  background-color: white;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  animation: slide-in 0.5s ease;\n  position: relative; /* Add this line */\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}\n\n\n@keyframes slide-in {\n  from {\n    transform: translateY(-50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Media query for screens up to 768px */\n@media screen and (max-width: 768px) {\n  .order-heading,\n  .order-filter-container {\n    margin-left: 0;\n    padding: 10px;\n  }\n\n  .order-search-bar,\n  .order-date-input {\n    width: calc(50% - 10px);\n    margin-right: 5px;\n  }\n\n  .order-reset-button {\n    width: calc(50% - 10px);\n    margin-right: 0;\n  }\n\n  .order-table-container {\n    width: 100%; /* Reset width for mobile */\n    margin-left: 0; /* Reset left margin for mobile */\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
